import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import axios from "axios";

const state = {
  tags: null,
  tagsPagination: null,
  contacts: null,
  currentContact: null,
  themes: null,
  globalThemes: null,
  languages: null,
};

const getters = {
  teams_get_tags: (state) => {
    return state.tags;
  },
  teams_get_tags_pagination: (state) => {
    return state.tagsPagination;
  },
  teams_get_contacts: (state) => {
    return state.contacts;
  },
  teams_get_current_contact: (state) => {
    return state.currentContact;
  },
  teams_get_themes: (state) => {
    return state.themes;
  },
  teams_get_global_themes: (state) => {
    return state.globalThemes;
  },
  teams_get_languages: (state) => {
    return state.languages;
  },
};

const mutations = {
  TEAMS_SET_TAGS(state, tags) {
    state.tags = tags;
  },
  TEAMS_SET_TAGS_PAGINATION(state, pagination) {
    state.tagsPagination = pagination;
  },
  TEAMS_SET_CONTACTS(state, contacts) {
    state.contacts = contacts;
  },
  TEAMS_SET_CURRENT_CONTACT(state, contact) {
    state.currentContact = contact;
  },
  TEAMS_RESET_CURRENT_CONTACT(state) {
    state.currentContact = null;
  },
  TEAMS_SET_THEMES(state, themes) {
    state.themes = themes;
  },
  TEAMS_SET_GLOBAL_THEMES(state, globalThemes) {
    state.globalThemes = globalThemes;
  },
  TEAMS_SET_LANGUAGES(state, languages) {
    state.languages = languages;
  },
};

const actions = {
  editTeam({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest")
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamPut(params, payload.data)
            .then((res) => {
              console.log("teamPut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  postDeleteTeam({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest")
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamRetirePost(params, payload)
            .then((res) => {
              console.log("teamRetirePost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteTeam({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest")
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamDelete(params, payload)
            .then((res) => {
              console.log("teamDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamLanguages({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest")
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamGet(params)
            .then((res) => {
              console.log("teamGet", res.data.data);
              commit("TEAMS_SET_LANGUAGES", res.data.data.languages);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamTags({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        name: payload.params.name ? payload.params.name : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTagsGet(params)
            .then((res) => {
              console.log("teamTagsGet", res.data.data);
              commit("TEAMS_SET_TAGS", res.data.data);
              commit("TEAMS_SET_TAGS_PAGINATION", res.data.meta.pagination);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamContacts({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "1000",
        order_col: payload.params.order_col ? payload.params.order_col : "updated_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        email: payload.params.email ? payload.params.email : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsGet(params)
            .then((res) => {
              console.log("teamContactsGet", res.data.data);
              commit("TEAMS_SET_CONTACTS", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "contacts",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  filter: {
                    //
                  },
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getContact({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.params) payload.params = {};
      payload.params = {
        contact: payload.contact,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactGet(params)
            .then((res) => {
              console.log("teamContactsContactGet", res.data.data);
              commit("TEAMS_SET_CURRENT_CONTACT", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "contact" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createContact({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsPost(params, payload.data)
            .then((res) => {
              console.log("teamContactsPost", res);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editContact({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactPut(params, payload.data)
            .then((res) => {
              console.log("teamContactsContactPut", res);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createContactImage({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.imageData.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactImagePost(params, payload.imageData.image)
            .then((res) => {
              console.log("teamContactsContactImagePost", res);
              const uploadedFile = res.data.data;
              params.file = res.data.data.uid;
              axios
                .put(res.data.data.upload_request.request_url, payload.imageData.file, {
                  headers: {
                    "Content-Type": payload.imageData.image.mime_type,
                  },
                })
                .then((res) => {
                  console.log(">>>>>>>>>>>>>>> UPLOADED SUCCCSFULLY TO S3", res, uploadedFile);
                  dispatch("createContactImageComplete", params)
                    .then((res) => {
                      commit("GLOBAL_LOADING_ENDED");
                      resolve(res);
                    })
                    .catch((err) => {
                      commit("GLOBAL_LOADING_ENDED");
                      reject(err);
                    });
                })
                .catch((err) => {
                  commit("GLOBAL_LOADING_ENDED");
                  reject(err);
                });
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createContactImageComplete({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactImageFileCompletePost(params)
            .then((res) => {
              console.log("teamContactsContactImageFileCompletePost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getContactImage({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactImageFileGet(params)
            .then((res) => {
              console.log("teamContactsContactImageFileGet", res);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getContactImagePreview({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        contact: payload.contact,
        file: payload.file,
        page: payload.params.page ? payload.params.page : "1",
        width: payload.params.width ? payload.params.width : "375",
        height: payload.params.height ? payload.params.height : "375",
        rendermethod: payload.params.rendermethod ? payload.params.rendermethod : "resize",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactImageFilePreviewImageRendermethodPageWidthHeightGet(params)
            .then((res) => {
              console.log("teamContactsContactImageFilePreviewImageRendermethodPageWidthHeightGet", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteContact({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactDelete(params)
            .then((res) => {
              console.log("teamContactsContactDelete", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteContactImage({ dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamContactsContactImageFileDelete(params)
            .then((res) => {
              console.log("teamContactsContactImageFileDelete", res.data.data);
              // commit('GLOBAL_LOADING_ENDED')
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              // commit('GLOBAL_LOADING_ENDED')
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          // commit('GLOBAL_LOADING_ENDED')
          reject(err);
        });
    });
  },
  getTeamThemes({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        has_global_theme: false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamThemesGet(params)
            .then((res) => {
              console.log("teamThemesGet", res.data.data);
              commit("TEAMS_SET_THEMES", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamGlobalThemes({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamThemesGGet(params)
            .then((res) => {
              console.log("teamGlobalThemesGet", res.data.data);
              commit("TEAMS_SET_GLOBAL_THEMES", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
